<template>
  <div class="single-customer-chat">
    <div v-if="isLoading" class="liveChatCenter">
      <img src="../resources/images/live-chat-welcome.svg" class="welcomeImg"  alt="Welcome" />
      <h3 class="sub-title">Loading conversation...</h3>
    </div>
    <div v-else class="single-customer-chat-page">
      <div :class="{ receiverDetailMode: receiverDetailMode }" class="defaultChatView">
        <header class="livechat-header">
          <div v-if="conversationid && activeCustomer && activeCustomer.channel" class="chatToolBar">
            <div class="chatbar-header">
              <VIcon class="ion-hide-lg-up backIcon" @click="() => $emit('home')" name="arrow-left-line" :size="-4"></VIcon>
              <div>
                <CustomerConnectedChannel :customer="activeCustomer" />
              </div>
              <div class="flex-start ion-align-items-center liveChatHeaderCustomerName">
                <div v-if="activeCustomer.name != 'unrecorded'" class="header" :title="activeCustomer.name">{{ activeCustomer.name }}</div>
                <div v-else class="header">Anonymous</div>

                <div>
                  <div class="flex-start ion-align-items-center customerInfo optin-status-tag optin-nostatus" v-if="activeCustomer.marketing_opt_in_state === 0">
                    <img src="@/resources/images/marketing-optin-nostatus.svg" alt="No status"/>
                    <span class="status">No status</span>
                  </div>
                  <div class="flex-start ion-align-items-center customerInfo optin-status-tag optin-subscribed" v-if="activeCustomer.marketing_opt_in_state === 1">
                    <img src="@/resources/images/marketing-optin-subscribed.svg" alt="Subscribed"/>
                    <span class="status">Subscribed</span>
                  </div>
                  <div class="flex-start ion-align-items-center customerInfo optin-status-tag optin-unsubscribed" v-if="activeCustomer.marketing_opt_in_state === -1">
                    <img src="@/resources/images/marketing-optin-unsubscribed.svg" alt="Unsubscribed"/>
                    <span class="status">Unsubscribed</span>
                  </div>
                </div>

                <div
                  v-if="
                    activeCustomer?.template?.type !== 'note' && 
                    activeCustomer?.channel_id != null &&
                    whatsAppSocialData?.id != null &&
                    String(activeCustomer.channel_id) !== String(whatsAppSocialData.id) &&
                    activeCustomer.platform == 'whatsapp'
                  "
                  class="disconnect_status"
                >
                  Disconnected
                </div>
              </div>
            </div>
            <div class="toolbar-end-buttons">
              <button class="icon-btn" @click="toggleCustomerDetails"> 
                <VIcon :class="{ ellipsisVerticalImage: receiverDetailMode }" name="more-vertical-line"></VIcon>
              </button>
            </div>
          </div>
        </header>
        <div ref="chat_container" class="liveChatDefault">
          <!-- Mention Agent Dialog -->
          <VDialog
            :open="mentionAgentMode"
            headline="Mention team member"
            modal
            @close="() => mentionAgentMode = false"
            :style="{ '--dialog-min-inline-size': '320px', '--dialog-max-inline-size': '400px' }"
          >
            <template #body>
              <div class="action-sheet-list">
                <button v-for="option in mentionAgentOptions" :key="option.text" class="action-sheet-item" @click="() => { option.handler(); mentionAgentMode = false; }">
                  {{ option.text }}
                </button>
              </div>
            </template>
          </VDialog>
          <!-- Actions Dialog -->
          <VDialog
            :open="actionModal"
            headline="Actions"
            modal
            @close="() => actionModal = false"
            :style="{ '--dialog-min-inline-size': '320px', '--dialog-max-inline-size': '400px' }"
          >
            <template #body>
              <div class="action-sheet-list">
                <button v-for="option in productActionOptions" :key="option.text" class="action-sheet-item" @click="() => { option.handler(); actionModal = false; }">
                  <VIcon v-if="option.icon" :name="option.icon" :size="-4" style="margin-right: 8px;"></VIcon>
                  {{ option.text }}
                </button>
              </div>
            </template>
          </VDialog>

          <!-- chats start -->
          <div v-if="!conversationid || !activeCustomer || !activeCustomer.channel" class="liveChatCenter">
            <img src="../resources/images/live-chat-welcome.svg" class="welcomeImg" alt="Welcome" />
            <h5>Welcome to Live Chat!</h5>
            <span class="text-medium">Click a conversation to view.</span>
          </div>

          <div v-else>
            <div class="text-center" style="margin-top: 10px;"  v-if="activeUserConversationMore && loadMoreChatLoadingShow == false && activeUserConversationDataResult.length > 0">
              <button class="btn-outline-dark btn-sm" @click="loadMoreMessages">
                Load more messages
              </button>
              <span class="text-medium" v-if="loadMoreChatLoadingShow == true">Loading...</span>
            </div>

            <div v-if="activeUserConversationDataResult.length > 0">
              <div class="chatComponentsContainer">
                <div class="inner_chatComponentsContainer">
                  <div class="singleChatComponent" v-for="resultOuter in activeUserConversationDataResult" :key="resultOuter.messageid" >
                    <div class="repliedFalse_container" v-if="resultOuter.replied == false" >
                      <!-- customer replied start -->
                      <div v-if="(resultOuter.template.type != 'note' && resultOuter.template != 'note') && resultOuter.template.type != 'status' && resultOuter.template.type != 'schedule'"
                            class="botProfileImageInitialChar bgImgContainer custom_tooltip_container" data-placement="right"
                        >
                        <div
                          class="bgImgContainerInner"
                          v-if="activeCustomer.image != null"
                          :style="renderCustomerImage_style_background(activeCustomer.image)"
                          :title="renderDateTime_lastReplyTimestamp(resultOuter.created, 'customReadable', false)"
                        ></div>
                        <div
                          class="bgImgContainerInner"
                          v-if="activeCustomer.image == null"
                          :style="{ background: 'url(' + require('@/resources/images/transparent-bg.png') + ') no-repeat' }"
                          :title="renderDateTime_lastReplyTimestamp(resultOuter.created, 'customReadable', false)"
                        ></div>

                        <span class="custom_tooltip_text left">{{ renderDateTime_lastReplyTimestamp(resultOuter.created, 'customReadable', false) }}</span>
                      </div>
                      <!-- customer replied end -->

                      <!-- message template start -->
                      <LivechatMessageTemplates 
                        :activeCustomer="activeCustomer"
                        :message="resultOuter"
                      />
                    
                      <!-- message template end -->

                      <!-- bot/agent replied start -->
                      <div
                        class="botProfileImageInitialChar custom_tooltip_container"
                        data-placement="left"
                        v-if="resultOuter.agent == null && (resultOuter.template.type == 'note' || (resultOuter.template.type == 'status' && resultOuter.message != null && resultOuter.message != '' && resultOuter.message != 'None') || resultOuter.template.type == 'schedule')"
                        :data-vertex="resultOuter.vertex"
                        :data-rule="resultOuter.rule"
                      >
                        <img :src="getShopLogoImage" alt="Shop Logo" />

                        <span class="custom_tooltip_text right">{{ renderDateTime_lastReplyTimestamp(resultOuter.created, 'customReadable', false) }}</span>
                      </div>

                      <div
                        class="botProfileImageInitialChar custom_tooltip_container"
                        v-if="resultOuter.agent != null && (resultOuter.template.type == 'note' || (resultOuter.template.type == 'status' && resultOuter.message != null && resultOuter.message != '' && resultOuter.message != 'None') || resultOuter.template.type == 'schedule')"
                      >
                        <img :src="resultOuter.agent.picture" v-if="resultOuter.agent.picture && resultOuter.agent.picture != ''" alt="Agent" />
                        <img :src="resultOuter.agent.image" v-else-if="resultOuter.agent.image && resultOuter.agent.image != ''" alt="Agent" />

                        <div class="botProfileImageInitialCharTextOnly" v-else-if="(!resultOuter.agent.picture || resultOuter.agent.picture == '') && (!resultOuter.agent.image || resultOuter.agent.image == '')">
                          {{ getNameInitials(resultOuter.agent.name) }}
                        </div>

                        <span class="custom_tooltip_text right">{{ renderDateTime_lastReplyTimestamp(resultOuter.created, 'customReadable', false) }}</span>
                      </div>
                      <!-- bot/agent replied end -->
                    </div>
                    <div class="repliedTrue_container" v-else >
                      <div v-for="result in resultOuter.template" :key="result.type" :data-type="result.type" >
                        
                        <div class="messageTemplateContainer statusMsgBubble statusMessageType" v-if="resultOuter.template.type == 'status' && resultOuter.message != null && resultOuter.message != '' && resultOuter.message != 'None'" >
                          <div class="normalchat_component msg_component statusInfo">
                            <p class="status-title ion-no-margin paddingBottom">Status info. message</p>
                            <div v-html="renderNormalChat(resultOuter.message)"></div>
                          </div>
                        </div>
                        
                        <!-- message template start -->
                        <LivechatMessageTemplates
                          :activeCustomer="activeCustomer" 
                          :resultText="result"  
                          :messageOrigin="resultOuter"
                        />
                        <!-- message template end -->

                        <!-- bot/agent replied start -->
                        <div
                          class="botProfileImageInitialChar custom_tooltip_container"
                          data-placement="left"
                          v-if="resultOuter.agent == null"
                          :data-vertex="resultOuter.vertex"
                          :data-rule="resultOuter.rule"
                        >
                          <img :src="getShopLogoImage" alt="Shop Logo" />

                          <span class="custom_tooltip_text right">{{ renderDateTime_lastReplyTimestamp(resultOuter.created, 'customReadable', false) }}</span>
                        </div>

                        <div
                          class="botProfileImageInitialChar custom_tooltip_container"
                          v-if="resultOuter.agent != null"
                        >
                          <img
                            :src="resultOuter.agent.picture"
                            v-if="resultOuter.agent.picture && resultOuter.agent.picture != ''"
                            alt="Agent"
                          />
                          <img
                            :src="resultOuter.agent.image"
                            v-else-if="resultOuter.agent.image && resultOuter.agent.image != ''"
                            alt="Agent"
                          />

                          <div
                            class="botProfileImageInitialCharTextOnly"
                            v-else-if="(!resultOuter.agent.picture || resultOuter.agent.picture == '') && (!resultOuter.agent.image || resultOuter.agent.image == '')"
                          >
                            {{ getNameInitials(resultOuter.agent.name) }}
                          </div>

                          <span class="custom_tooltip_text right">{{ renderDateTime_lastReplyTimestamp(resultOuter.created, 'customReadable', false) }}</span>
                        </div>
                        <!-- bot/agent replied end -->

                        <!-- reactions viewer start -->
                        <div>

                        </div>
                        <!-- reactions viewer end -->

                        <!-- reactions opener start -->
                        <div>

                        </div>
                        <!-- reactions opener end -->

                        <!-- message status start -->
                    
                        <div class="messageReadStatusArea custom_tooltip_container" v-if="resultOuter.status && resultOuter.status != null">
                          <div>
                            <VIcon :class="{ 'messageReadStatus': resultOuter.status == 'read', 'messageRejectedStatus' : resultOuter.status == 'rejected'}" :style="{ color: statusIconColor(resultOuter) === 'medium' ? 'var(--gray-04)' : '' }" :name="statusIcon(resultOuter)" style="font-size: 14px"></VIcon>
                            <span class="custom_tooltip_text right">{{ statusMessage(resultOuter) }}</span>
                          </div>
                        </div>

                        <!-- message status end -->

                        <!-- undelivered message tag start -->
                        <div class="undeliveredMessageInfoArea custom_tooltip_container" v-if="resultOuter.delivered == false && resultOuter.status !== 'rejected'">
                          <VIcon :name="warningOutline" connotation="alert"></VIcon>
                          <span class="custom_tooltip_text right">{{ undeliveredMessage(resultOuter) }}</span>
                        </div>
                        <!-- undelivered message tag end -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="text-center loadingScreen">
              <div>
                <img src="../resources/images/conversation.png" class="emptyImg" alt="No Conversation"/>  
                <h5>Yet to strike a conversation &#x1F910;</h5>
                <span class="sub-title text-medium">This customer hasn't sent a message or replied to an automation yet!</span>
              </div>
            </div>
          </div>
          <!-- chats end -->
        </div>
        <footer v-if="conversationid && activeCustomer && activeCustomer.channel" class="chat-footer">
          <!-- composer input area start -->
          <div class="infoBanner opted-out-banner" v-if="activeCustomer.marketing_opt_in_state === -1">
            <VIcon :name="warningOutline" connotation="alert" class="icon"></VIcon>
            <div class="column">
              <div class="text">User opted-out - reply only to their messages, no proactive or marketing outreach.</div>
            </div>
          </div>

          <div class="messageInputBox">
            <div class="chatInputBarLoadingArea text-center" v-if="chatInputBarLoadingIsOn == true" >
              <div>
                <p class="loadingTextWithImage">
                  <VIcon name="cloud-line" style="vertical-align: middle;"></VIcon>
                  <span class="text-medium" style="vertical-align: middle; padding-left: 8px;" >Uploading...</span>
                </p>
              </div>
            </div>
            <template v-else-if="activeCustomer.channel == 'whatsapp'">
              <div class="chatInputBarLoadingArea sendMessageContainer" v-if="isWhatsappChat_old24H || isWhatsappChat_sendTemplate || activeUserConversationDataResult.length === 0" >
                <div v-if="activeUserConversationDataResult.length === 0">
                  <p class="templateMessage ion-no-margin">This customer has never interacted with your WhatsApp Number before. You can only send them a pre-created message template</p>
                </div>
                <div v-else>
                  <p class="templateMessage ion-no-margin">You cannot initiate an action for a customer who's last message was received more than 24 hours ago</p>
                </div>
                <button class="btn-primary" @click="() => { sendWhatsappTemplate = true; fetchTemplates(); }">
                  Send Template Message
                </button>
              </div>
              <div class="chatInputBarLoadingArea sendMessageContainer" v-else-if="activeCustomer?.template?.type !== 'note' && activeCustomer?.channel_id != null &&
              whatsAppSocialData?.id != null && String(activeCustomer?.channel_id) !== String(whatsAppSocialData?.id)">
                <div>
                  <p class="templateMessage ion-no-margin">This conversation was initiated from a different phone number. You can still view this chat but replying is no longer supported.</p>
                </div>
              </div>
            </template>
            <div class="humanTakeoverMessageInputContainer">
              <span v-if="activeCustomer.active && activeCustomer.vertex !== 2125 && !activeCustomer.assigned_to && !isWhatsappChat_old24H && !isWhatsappChat_sendTemplate" class="botActiveTextNoticeBarOverInput" :class="{ botActiveMargin : activeCustomer.channel !== 'whatsapp' }">
                Bot is active, type a message to pause the bot and take over the conversation.
              </span>
              <div class="inputContainerInnerInline mobileLikeInputContainer" v-if="checkIfToShow_inputContainerInnerInline" style="display: flex;" >
                <button
                  type="button"
                  class="submitBtn bottomProductChatSendBtn"
                  id="bottomProductChatSendBtn"
                  @click="() => actionModal = true"
                  v-if="actionsPanelEnabled && (whatsappConnected == true  && activeCustomer.channel === 'whatsapp' && calculate24Plus1RuleForCustomer(activeCustomer.userReplyTimestamp) <= 24)"
                  style="align-self: flex-end;"
                >
                  <VIcon name="add-line" style="color: white; font-size: 20px;"></VIcon>
                </button>
                <my-input
                  autofocus
                  textarea
                  id="newLiveChatMessage"
                  :style="noteMode ? { backgroundColor: '#EDDEFF' } : { backgroundColor: '#ffffff' }"
                  :rows="1"
                  emoji
                  name="bottomProductChatInputText"
                  :value="newChatMessage"
                  @onInput="changeChatInput"
                  @onKeyPress="newMessageKeyPressHandler"
                  @onKeyDown="newMessageKeyPressHandler"
                  :placeholder="chatPlaceholder"
                  :maxlength="getMaxLengthForChannels"
                  :class="{ noteMessageType : noteMode }"
                  :inputStyle="{borderRadius: '20px'}"
                  :iconStyle="{ bottom: '5px' }"
                />

                <button
                  :disabled="newChatMessage == undefined || newChatMessage == ''"
                  type="button"
                  class="submitBtn bottomProductChatSendBtn"
                  id="bottomProductChatSendBtn"
                  @click="sendMessage"
                  style="align-self: flex-end;"
                >
                  <img src="@/resources/images/send-chat-icon.png" alt="Send Chat" />
                </button>
                <div class="actionButtonsOverChatSendInputBar_container" >            
                  <!-- note image -->
                  <span class="tooltip_container">
                    <img v-if="isDarkMode" @click.stop="switchNoteMode" src="@/resources/images/page-inbox-add-note-dark.svg" class="singleActionButtonIcon" alt="Add Note Dark Mode" />
                    <img v-else @click.stop="switchNoteMode" src="@/resources/images/page-inbox-add-note.svg" class="singleActionButtonIcon" alt="Add Note Light Mode" />
                    <span class="tooltip_text top"> Internal Note </span>
                  </span>
                  
                  <!-- attach Image -->
                  <span v-if="activeCustomer.platform !== 'sms' && (newChatMessage == undefined || newChatMessage == '')" class="tooltip_container">
                    <img v-if="isDarkMode" src="@/resources/images/page-inbox-attach-dark.svg" class="singleActionButtonIcon" @click="openAttachmentModal" alt="Attach Dark Mode" >
                    <img v-else src="@/resources/images/page-inbox-attach.svg" class="singleActionButtonIcon" @click="openAttachmentModal" alt="Attach Light Mode" >
                    <span class="tooltip_text top"> Attach </span>
                  </span>
                  <!-- Stop Current Bot Flow -->
                  <span v-if="activeCustomer.active && activeCustomer.vertex !== 2125 && !activeCustomer.assigned_to" class="tooltip_container">
                    <img src="@/resources/images/stop-current-flow.svg" class="singleActionButtonIcon" @click="confirmStopCurrentFlowModal = true" alt="Stop Current Flow">
                    <span class="tooltip_text top"> Stop current flow </span>
                  </span>
                </div>
              </div>
            </div>            
          </div>
          <!-- composer input area end -->
        </footer>
      </div>
      <!-- Customer Information side Bar   -->
      <div v-if="conversationid && activeCustomer && activeCustomer.channel" :class="{ receiverDetailMode: receiverDetailMode }" class="customer-info-container">
        <div class="chat-toolbar show-xs">
          <div class="toolbar-start-buttons marginleft">
            <VIcon @click="() => receiverDetailMode = false" name="arrow-left-line" :size="-5" style="cursor: pointer"></VIcon>
            <h2 class="prdt-title ion-no-margin">Go Back</h2>
          </div>
        </div>
          <!-- profile start -->
          <div v-if="receiverDetailMode && activeCustomer" class="customerDetails">
            <single-user-detail
              :conversationid="conversationid"
              :activeCustomer="activeCustomer"
              :page_conversation_id="page_conversation_id"
              :pageid="pageid"
              :platform="platform"
              @user_info_updated="init('userData')"
              @resolved_chat="init('resolvedChat')"
              :agentReAssignmentAllowed="agentReAssignmentAllowed"
              @reassign="() => reAssignModal = true"
              @sendReminder="() => sendReminderModel = true"
            />
          </div>
          <!-- profile end -->
      </div>
    </div>
  </div>

  <!-- Ressign Agents Modal -->
  <VDialog
    v-if="allGroupsResult.length"
    :open="reAssignModal"
    headline="Re-assign"
    modal
    @close="() => { reAssignModal = false; selectedReassignGroup = undefined; searchAgentToReassignText = ''; allAgentsResult_apiBased_data = []; allAgentsOfSelectedGroupResult = []; }"
    :style="{ '--dialog-min-inline-size': '500px', '--dialog-max-inline-size': '600px', '--dialog-min-block-size': '500px', '--dialog-max-block-size': '80vh' }"
  >
    <template #body>
      <div class="reassign-modal-body">
        <div v-if="allGroupsResult && allGroupsResult.length">
          <div>
            <p class="sub-title">Select a group</p>
            <VSelect v-model="selectedReassignGroup" aria-label="group" placeholder="Select group" appearance="ghost" class="vivid-select">
              <VOption v-for="thisbRole in allGroupsResult" :key="thisbRole.id" :value="thisbRole.id" :text="thisbRole.name"></VOption>
            </VSelect>
          </div>
          <div v-if="loadingRoles" class="loading-agents-indicator">
            <VEmptyState icon="search-line" />
            <span>Loading agents...</span>
          </div>
          <div v-if="selectedReassignGroup !== undefined && allAgentsOfSelectedGroupResult.length > 0">
            <p class="sub-title">Search agent</p>
            <div class="selectProductSearch">
              <VTextField
                v-model="searchAgentToReassignText"
                type="text"
                @input="searchAgentToReassignTextChanger"
                @keyup="searchAgentToReassignTextChanger"
                placeholder="Search agent"
                aria-label="search agent"
                appearance="ghost"
                class="vivid-input"
              ></VTextField>
            </div>
          </div>
          <div v-if="allAgentsOfSelectedGroupResult.length > 0">
            <!-- No search active: show full group list -->
            <span v-if="allAgentsResult_apiBased_data.length == 0 && searchAgentToReassignText.length <= 2">
              <div v-if="selectedReassignGroup">
                <div v-if="allAgentsOfSelectedGroupResult?.length" class="agent-list-item">
                  <div class="agent-img-container">
                    <img src="@/resources/images/page-inbox-human-support.svg" alt="Human Support" />
                  </div>
                  <div class="agent-item-content">
                    <h2>Assign to group</h2>
                    <p>The conversation will get assigned to one of the agents in the group</p>
                  </div>
                  <button @click="assignChat('group', selectedReassignGroup)" class="btn-primary btn-sm"> Assign </button>
                </div>
              </div>
              <div v-if="allAgentsOfSelectedGroupResult?.length">
                <template v-for="thisRole in allAgentsOfSelectedGroupResult" :key="thisRole.id">
                  <div v-if="thisRole.id !== activeCustomer?.assigned_to?.id" class="agent-list-item">
                    <div class="agent-img-container">
                      <img :src="thisRole.picture && thisRole.picture.length ? thisRole.picture : fallbackImage" alt="Agent" />
                    </div>
                    <span class="agent-item-name">{{ thisRole.name }}</span>
                    <button @click="assignChat('agent', thisRole.id)" class="btn-primary btn-sm"> Assign </button>
                  </div>
                </template>
              </div>
            </span>
            <!-- Search active and results found -->
            <span v-else-if="allAgentsResult_apiBased_data.length > 0">
              <div>
                <template v-for="thisRole in allAgentsResult_apiBased_data" :key="thisRole.id">
                  <div v-if="thisRole.id !== activeCustomer?.assigned_to?.id" class="agent-list-item">
                    <div class="agent-img-container">
                      <img :src="thisRole.picture && thisRole.picture.length ? thisRole.picture : fallbackImage" alt="Agent" />
                    </div>
                    <span class="agent-item-name sub-title">{{ thisRole.name }}</span>
                    <button @click="assignChat('agent', thisRole.id)" class="btn-primary btn-sm"> Assign </button>
                  </div>
                </template>
              </div>
            </span>
            <!-- Search active but no results found -->
            <div v-else class="text-center empty-message">
              <img src="../resources/images/empty_purchases.svg" class="emptyProducts" alt="No Agents Found"/>
              <h5>No agents found!</h5>
            </div>
          </div>
          <div v-else>
            <div v-if="allAgentsOfSelectedGroupResult.length == 0 && selectedReassignGroup !== undefined && !loadingRoles" class="text-center empty-message">
              <img src="../resources/images/empty_purchases.svg" class="emptyProducts" alt="No Agents or Groups Found"/>
              <h5>No Agents/Groups found!</h5>
            </div>
          </div>
        </div>
        <div v-else-if="allAgentsResult.length">
          <template v-for="thisRole in allAgentsResult" :key="thisRole.id">
            <div v-if="thisRole.id !== activeCustomer?.assigned_to?.id" class="agent-list-item">
              <div class="agent-img-container">
                <img :src="thisRole.picture && thisRole.picture.length ? thisRole.picture : fallbackImage" alt="Agent" />
              </div>
              <span class="agent-item-name sub-title">{{ thisRole.name }}</span>
              <button @click="assignChat('agent', thisRole.id)" class="btn-primary btn-sm">
                Assign
              </button>
            </div>
          </template>
        </div>
      </div>
    </template>
  </VDialog>
  <!-- Send Whatsapp Template -->
  <VDialog
    :open="sendWhatsappTemplate"
    headline="Send template message"
    modal
    @close="() => {sendWhatsappTemplate = false; resetTemplateDataForWA(); newChatMessage = undefined;}"
    :style="{ '--dialog-min-inline-size': '600px', '--dialog-max-inline-size': '700px' }"
  >
    <template #body>
      <div>
        <div class="info-box infoMessage">
          <VIcon name="info-line" :size="-5" connotation="cta" class="infoIcon"></VIcon>
          <p class="info-text ion-no-margin">You will be charged for this message</p>
        </div>
        <WhatsAppCreateMessage v-if="sendWhatsappTemplate" ref="whatsAppMessageTemplate" moduleType='liveChat' :disableDynamicURL="true" :allWhatsappTemplateData="allTemplates" @fileUploading="(value) => { fileUploadings = value }" :conversationid="conversationid"></WhatsAppCreateMessage>
      </div>
    </template>
    <template #action-items>
      <VButton connotation="cta" appearance="filled" :label="commonLoader ? 'Sending...' : 'Send'" :disabled="commonLoader || fileUploadings" @click="sendTemplateAlert"></VButton>
    </template>
  </VDialog>
  <!-- Send Location modal -->
  <VDialog
    :open="sendLocationModal"
    headline="Send location"
    modal
    @close="() => sendLocationModal = false"
    :style="{ '--dialog-min-inline-size': '450px', '--dialog-max-inline-size': '550px' }"
  >
    <template #body>
      <div>
        <div class="marginBottom">
          <p class="sub-title">Button title<span class="trashIcon">*</span></p>
          <VTextField type="text" :maxlength="20" aria-label="Button title" placeholder="Enter button title" v-model="sendLocation.buttonTitle" appearance="ghost" class="vivid-input"></VTextField>
        </div>
        <div>
          <p class="sub-title">Address <span class="trashIcon">*</span></p>
          <autofillAddress v-model="sendLocation.address" class="sctn-input" @onSearch="fillLocations"> </autofillAddress>
        </div>
      </div>
    </template>
    <template #action-items>
      <VButton connotation="cta" appearance="filled" :label="commonLoader ? 'Sending...' : 'Send'" :disabled="sendLocation.buttonTitle == '' || sendLocation.address == '' || commonLoader" @click="sendLocationTemplate"></VButton>
    </template>
  </VDialog>
  <!-- Send Contact Modal -->
  <VDialog
    v-if="sendContactModal"
    :open="sendContactModal"
    headline="Send contact"
    modal
    @close="() => sendContactModal = false"
    :style="{ '--dialog-min-inline-size': '450px', '--dialog-max-inline-size': '550px' }"
  >
    <template #body>
      <div>
        <div class="marginBottom">
          <p class="sub-title">Enter contact name<span class="trashIcon">*</span></p>
          <VTextField type="text" :maxlength="20" aria-label="Enter contact name" v-model="sendContact.name" placeholder="Enter contact name" appearance="ghost" class="vivid-input"></VTextField>
        </div>
        <div>
          <p class="sub-title">Enter contact number <span class="trashIcon">*</span></p>
          <mobile-input v-model:countryCode="sendContact.countryCode" v-model:mobile="sendContact.number"></mobile-input>
        </div>
      </div>
    </template>
    <template #action-items>
      <VButton connotation="cta" appearance="filled" :label="commonLoader ? 'Sending...' : 'Send'" :disabled="sendContact.name == undefined || sendContact.number == undefined || sendContact.countryCode == undefined || sendContact.number == 0 || sendContact.number < 0 || commonLoader" @click="sendContactTemplate"></VButton>
    </template>
  </VDialog>
  <!-- Attach and Send Modal -->
  <VDialog
    :open="attachAndSendModal"
    headline="Attach & send to chat"
    modal
    @close="() => {attachAndSendModal = false; chatInputBarLoadingIsOn = false; uploadedURLData = { filename: undefined, file_name: undefined, file_url: '', mime_type: undefined }}"
    :style="{ '--dialog-min-inline-size': '550px', '--dialog-max-inline-size': '650px' }"
  >
    <template #body>
      <div v-if="activeSendAndAttachTab === 'recentTab'">
        <div v-if="recentUploadedFiles.length">
          <div class="recent-files-header custBorder">
            <div class="recent-files-col-8">
              <div class="flex-start paddingBottom flexText">
                <p class="title ion-no-margin">Recently Uploaded</p>
                <HelpTooltip>
                  Recently uploaded files will be lost if the page is refreshed.
                </HelpTooltip>
              </div>
            </div>
            <div class="recent-files-col-4">
              <p class="title ion-no-margin text-right">Actions</p>
            </div>
          </div>
          <div v-for="thisFile in recentUploadedFiles" :key="thisFile.id" class="recent-file-row custBorder">
            <div class="recent-files-col-8">
              <div class="recent-file-item">
                <img width="40" :src="renderImage(thisFile.url)" @error="handleImageError" class="productImg" alt="Recently Uploaded File"/>
                <div class="custPadding">
                  <a :href="thisFile.url" target="_blank" >
                    <span v-if="thisFile.name == '' || thisFile.name == 'None' || thisFile.name == null">{{ thisFile.url }}</span>
                    <span v-else>{{ thisFile.name }}</span>
                  </a>
                </div>
              </div>
            </div>
            <div class="recent-files-col-4 text-right">
              <button class="btn-primary btn-sm" @click="selectRecentUploadFile(thisFile)" :disabled="sendingFileMessage">
                {{ sendingFileMessage ? 'Sending...' : 'Send to chat' }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="activeSendAndAttachTab === 'imageTab'">
        <div class="flexBox">
          <div class="info-box">
            <VIcon name="info-line" :size="-5" connotation="cta" class="infoIcon" style="padding-right: 10px;"></VIcon>
            <p class="title ion-no-margin">Max file size {{ activeCustomer.channel === "whatsapp" ? '5MB' : activeCustomer.channel === "googlercs" ? '100MB' :'4MB' }} {{  supportedImageTypes }}</p>  
          </div>
          <div class="info-box">
            <VIcon name="info-line" :size="-5" connotation="cta" class="infoIcon" style="padding-right: 10px;"></VIcon>
            <p class="title ion-no-margin">
              Max file size 
              {{ activeCustomer.channel === "whatsapp" ? '16MB' : activeCustomer.channel === "googlercs" ? '100MB' : '25MB' }} 
              {{ activeCustomer.channel === "whatsapp" ? '(.mp4 only)' : activeCustomer.channel === "googlercs" ? '(.mp4, .mpeg, .mpeg4, .m4v, .webm only)' : '(.mp4, .mpeg, .mpeg4, .m4v, .webm only)' }}
            </p>
          </div>
          <div class="info-box">
            <VIcon name="info-line" :size="-5" connotation="cta" class="infoIcon" style="padding-right: 10px;"></VIcon>
            <p class="title ion-no-margin">Max file size {{ ['whatsapp', 'googlercs'].includes(activeCustomer.channel) ? '100MB' : '25MB' }} {{ supportedFiles}}</p>  
          </div>
        </div>
        <div v-if="uploadedURLData.file_url" class="imageContainer">
          <img v-if="uploadFileType === 'image'" :src="uploadedURLData.file_url" class="uploadedImg cursorPointer" alt="uploadedImage" />
          <template v-else-if="uploadFileType === 'video'">
            <video v-if="isBrowserPlayableVideo && !videoPlaybackError" class="uploadedImg cursorPointer" controls @error="videoPlaybackError = true">
              <source :src="uploadedURLData.file_url" :type="uploadedURLData.mime_type" />
            </video>
            <div v-else class="flex-center">
              <VideoFallback :url="uploadedURLData.file_url" />
            </div>
          </template>
          <a v-else-if="uploadFileType === 'document'" :href="uploadedURLData.file_url" target="_blank">{{ uploadedURLData.file_name || uploadedURLData.filename }}</a>
        </div>
        <div>
          <upload-files-v-2 uploadURLEnabled
            :type="'image/video/document'"
            @url-uploaded="(d) => handleUrlUpload(d)"
            :meta="{is_export: false, is_broadcast: false, is_redact: false, is_public: true, conversation_id: conversationid, channel: activeCustomer.channel}"
            :multiple="false" v-model:loading="filesUploading" @send-upload-data="getUploadedURLData"> 
            <button :disabled="filesUploading" class="btn-outline-secondary btn-block">
              <VIcon v-if="!filesUploading" name="file-line" class="icon icon-purple"></VIcon>
              <VProgressRing v-if="filesUploading" :size="-4" />
              <span v-else>Upload</span>
            </button>
          </upload-files-v-2>
        </div>
      </div>
    </template>
    <template v-if="activeSendAndAttachTab === 'imageTab'" #action-items>
      <VButton connotation="cta" appearance="filled" :label="filesUploading || sendingFileMessage ? (filesUploading ? 'Uploading...' : 'Sending...') : 'Send to chat'" @click="confirmSendAttachment" :disabled="filesUploading || sendingFileMessage || !(uploadedURLData.file_url !== '')"></VButton>
    </template>
  </VDialog>
  <!-- Send Reminder Model -->
  <VDialog
    :open="sendReminderModel"
    headline="Set reminder for this customer"
    modal
    @close="() => sendReminderModel = false"
    :style="{ '--dialog-min-inline-size': '450px', '--dialog-max-inline-size': '550px' }"
  >
    <template #body>
      <div class="optionsContainer">
        <p class="sub-title">Remind me:</p>
        <VRadioGroup v-model="reminderValue" name="reminder-options">
          <VRadio value="1-hours" label="in 1 hour"></VRadio>
          <VRadio value="2-hours" label="in 2 hours"></VRadio>
          <VRadio value="1-days" label="tomorrow, same time"></VRadio>
          <VRadio value="2-days" label="in 2 days, same time"></VRadio>
          <VRadio value="7-days" label="in a week, same time"></VRadio>
          <VRadio value="custom" label="Custom"></VRadio>
        </VRadioGroup>
        <div class="pre_text" v-if="reminderValue == 'custom'">
          <VTextField type="number" placeholder="1" @input="customTime = removeNegativeSign(customTime)" v-model="customTime" aria-label="Custom" appearance="ghost" class="vivid-input"></VTextField>
          <VSelect v-model="timeFormatOptions" aria-label="timeFormat" placeholder="Select" appearance="ghost" class="vivid-select">
            <VOption value="minutes" text="Minutes"></VOption>
            <VOption value="hours" text="Hours"></VOption>
            <VOption value="days" text="Days"></VOption>
          </VSelect>
        </div>
        <div>
          <p class="sub-title">Add reminder note: (Max 1000 characters) </p>
          <my-input
            aria-label="title"
            :textarea="true"
            :emoji="false"
            :lengthCounter="true"
            id="reminder"
            :rows="4"
            name="reminder"
            placeholder="Add reminder note" 
            :value="sendReminderNote"
            @onInput="(prop) => sendReminderNote = prop"
            :maxlength="1000"
            class="reminderMargin"
            :lengthStyle="{right: '10px'}"
          />
        </div> 
      </div>
    </template>
    <template #action-items>
      <VButton connotation="cta" appearance="filled" :label="settingUpReminder ? 'Setting up a reminder...' : 'Set reminder'" :disabled="(sendReminderNote == '' && customTime == '') || settingUpReminder" @click="setAgentReminder"></VButton>
    </template>
  </VDialog>
  <!-- Send ShortCut Modal -->
  <VDialog
    :open="sendShortcutMode"
    headline="Message Shortcut"
    modal
    @close="() => {sendShortcutMode = false;}"
    :style="{ '--dialog-min-inline-size': '550px', '--dialog-max-inline-size': '650px' }"
  >
    <template #body>
      <div>
        <VTextField v-model="shortcutSearch" type="text" placeholder="Search shortcuts" aria-label="Search shortcuts" appearance="ghost" class="vivid-input vmb-10"></VTextField>
        <div class="shortcut-table">
          <div class="shortcut-header">
            <div class="shortcut-col name">Shortcut</div>
            <div class="shortcut-col message">Message</div>
          </div>
          <div v-if="filteredShortcutOptions.length">
            <div
              class="shortcut-row"
              v-for="(option, index) in filteredShortcutOptions"
              :key="index"
              @click="sendShortcut(option.response)"
            >
              <div class="shortcut-col name txt_clr_primary">{{ '/' + option.name }}</div>
              <div class="shortcut-col message">{{ option.response }}</div>
            </div>
          </div>
          <div v-else class="no-results">
            <img src="../resources/images/not-found.svg" alt="not_found" class="filterImg" />
            <h5>No shortcuts matching this filter!</h5>
          </div>
        </div>
      </div>
    </template>
  </VDialog>

  <!-- Takeover confirmation dialog -->
  <VDialog
    :open="confirmTakeoverChatFromOtherAgent"
    headline="Alert"
    modal
    @close="() => { confirmTakeoverChatFromOtherAgent = false; taskToBeDone_after_confirmTakeoverChatFromOtherAgent = ''; }"
  >
    <template #body>
      <p class="vtext-body">This chat is already assigned to {{ activeCustomer?.assigned_to?.name }}. Do you wish to take over the conversation from them?</p>
    </template>
    <template #action-items>
      <VButton class="vvd-btn-cancel" appearance="filled" label="Don't Reassign" @click="() => { confirmTakeoverChatFromOtherAgent = false; taskToBeDone_after_confirmTakeoverChatFromOtherAgent = ''; }"></VButton>
      <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Confirm" @click="() => {
        const task = taskToBeDone_after_confirmTakeoverChatFromOtherAgent;
        confirmTakeoverChatFromOtherAgent = false;
        taskToBeDone_after_confirmTakeoverChatFromOtherAgent = '';
        if (task === 'sendMessageFinal') { sendMessageFinal(); }
        else if (task === 'sendMessageTemplate') { sendTemplate(); }
      }"></VButton>
    </template>
  </VDialog>

  <!-- Stop current flow confirmation dialog -->
  <VDialog
    :open="confirmStopCurrentFlowModal"
    headline="Are you sure?"
    modal
    @close="() => { confirmStopCurrentFlowModal = false; }"
  >
    <template #body>
      <p class="vtext-body">{{ activeCustomer?.name == undefined ? 'You want to stop the current flow of this customer' : 'You want to stop the current flow of ' + activeCustomer?.name + '.' }}</p>
    </template>
    <template #action-items>
      <VButton class="vvd-btn-cancel" appearance="filled" label="Cancel" @click="() => { confirmStopCurrentFlowModal = false; }"></VButton>
      <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Confirm" @click="stopCurrentFlow"></VButton>
    </template>
  </VDialog>
</template>

<script>
import "/src/resources/css/page-inbox.css";
import apiInterceptor from '@/shared/apiInterceptor';
import { ref } from 'vue';
import { calculate24Plus1RuleForCustomer } from '@/helpers/chat.helpers';
import { renderNormalChat } from '@/helpers/text.helpers';
import { useChatScroll } from '@/composables/useChatScroll';
import { renderDateTime_lastReplyTimestamp } from '@/helpers/date.helpers';
// Ionic imports removed - migrated to Vivid
import singleUserDetail from "../components/singleUserDetail";
import myInput from '../components/myInput.vue';
import MobileInput from '../components/mobileInput.vue';
import CustomerConnectedChannel from '../components/customerConnectedChannel.vue';
import autofillAddress from '/src/components/autofill-address.vue';
import LivechatMessageTemplates from "/src/components/livechatMessageTemplates.vue";
import { removeNegativeSign } from '/src/helpers/measurement.helpers.js';
import { getNameInitials } from '/src/helpers/global.helpers.js';
import { isBrowserPlayableMimeType } from '@/helpers/video.helpers';
import { getShopLogoImage as _getShopLogoImage } from '@/helpers/user.helpers';
import WhatsAppCreateMessage from "../pages/broadcast/whats-app-create-message.vue";
import { whatsappTemplatesQueryOptions } from '@/composables/useWhatsappTemplates';
import uploadFilesV2 from "@/components/uploadFilesV2.vue";
import fallbackImage from '/src/resources/images/page-inbox-human-support.svg';
import HelpTooltip from "/src/components/HelpTooltip.vue";
import VideoFallback from "@/components/VideoFallback.vue";

import { queryClient } from '@/shared/queryClient';
import { teamMembersQueryOptions } from '@/composables/useTeamMembers';
import { livechatShortcutsQueryOptions } from '@/composables/useLivechatShortcuts';
import { livechatBusinessRolesQueryOptions } from '@/composables/useLivechatBusinessRoles';
import { useAuthStore } from '@/stores/auth';
import { useUIStore } from '@/stores/ui';
import { useSocialChannels } from '@/composables/useSocialChannels';
import { useRoleDetails } from '@/composables/useRoleDetails';
import { checkIfThereIsNoLogoThenShowTransparentImage, renderCustomerImage_style_background } from '@/helpers/image.helpers';
import { environment } from '@/shared/env';

export default {
  mixins: [],
  props: {
    conversationid: {
      type: String,
      default: undefined,
    },
  },
  setup() {
    const chat_container = ref(null);
    const { scrollToBottom } = useChatScroll(chat_container);
    const { whatsappConnected, whatsAppSocialData, getChannelFromPageActive } = useSocialChannels();
    const { roleDetails } = useRoleDetails();
    return { chat_container, scrollToBottom, whatsappConnected, whatsAppSocialData, getChannelFromPageActive, roleDetails };
  },
  data() {
    return {
      warningOutline: 'warning-line',
      checkmarkOutline: 'check-line',
      checkmarkDoneOutline: 'check-double-line',
      locationOutline: 'pin-line',
      banOutline: 'close-circle-line',
      close: 'close-solid',
      star: 'star-line',
      searchOutline: 'search-line',
      colorWandOutline: 'flash-line',
      imageOutline: 'image-line',
      videocamOutline: 'video-line',
      documentOutline: 'clear-file-line',
      callOutline: 'call-line',
      mailOutline: 'envelope-line',
      fallbackImage,
      chevronDownOutline: 'chevron-down-line',
      isWhatsappChat_old24H: false,
      isWhatsappChat_sendTemplate: false,
      isWhatsappSendTemplateEnabled: false,
      sendWhatsappTemplate: false,
      searchTerm: '',
      UPLOAD_FILE_TYPE: {
        image: "image",
        video: "video",
        document: "document",
      },
      activeCustomer: {},
      activeUserConversationDataResult: [],
      chatInputBarLoadingIsOn: false,
      allAgentsResult: [],
      allGroupsResult: [],
      allAgentsOfSelectedGroupResult: [],
      allAgentsResult_apiBased_data: [],
      activeUserConversationCursor: undefined,
      activeUserConversationMore: false,
      loadMoreChatLoadingShow: false,
      receiverDetailMode: false,
      newChatMessage: undefined,
      page_conversation_id: undefined,
      pageid: undefined,
      platform: undefined,
      noteMode: false,
      mentionAgentMode: false,
      sendShortcutMode: false,
      allShortcuts: [],
      actionModal: false,
      confirmTakeoverChatFromOtherAgent: false,
      taskToBeDone_after_confirmTakeoverChatFromOtherAgent: "",
      selectedReassignGroup: undefined,
      searchByNameOrEmailText: "",
      reAssignModal: false,
      sendReminderModel: false,
      agentReAssignmentAllowed: true,
      actionsPanelEnabled: true,
      normalPusherNotifications: [],
      sendLocationModal: false,
      sendContactModal: false,
      sendLocation: {
        buttonTitle: undefined,
        address: undefined,
      },
      sendContact: {
        name: undefined,
        number: undefined,
        countryCode: undefined
      },
      sendLocationLatitudeText: undefined,
      sendLocationLongitudeText: undefined,
      attachAndSendModal: false,
      activeSendAndAttachTab: "imageTab",
      recentUploadedFiles: [],
      waitForconfirmation: true,
      sendingFileMessage: false,
      document: document,
      sendReminderNote: '',
      reminderValue: '1-hours',
      customTime: '',
      timeFormatOptions: 'minutes',
      settingUpReminder: false,
      searchAgentToReassignText: '',
      commonLoader: false,
      fileUploadings: false,
      sentViaURL: false,
      uploadedURLData: {
        filename: undefined,
        file_name: undefined,
        file_url: '',
        mime_type: undefined
      },
      uploadingFiles: false,
      filesUploading: false,
      videoPlaybackError: false,
      isMobile: window?.innerWidth && window?.innerWidth > 1200 ? false : true,
      allTemplates: [],
      shortcutSearch: '',
      confirmStopCurrentFlowModal: false,
      loadingRoles: false
    };
  },
  components: {
    singleUserDetail,
    myInput,
    MobileInput,
    VideoFallback,
    CustomerConnectedChannel,
    autofillAddress,
    LivechatMessageTemplates,
    WhatsAppCreateMessage,
    uploadFilesV2,
    HelpTooltip,
  },
  emits: ['home', 'resolved_chat_init'],
  async mounted() {
    if (this.conversationid) await this.init();

    window.addEventListener("online", this.handleConnectionChange);
    window.addEventListener("offline", this.handleConnectionChange);


    document.addEventListener("new-message", (e) => {
      this.parseNewConversationDataReceivedFromPusher(e.detail, false);
    });

    document.addEventListener("new-message-via-agent-routing", (e) => {
      this.parseNewConversationDataReceivedFromPusher(e.detail, true);
    });

    document.addEventListener("customer_info_update", (e) => {
      this.updateCustomerMarketingOptinStatusHandler(e.detail);
    });
  },
  beforeUnmount() {
    window.removeEventListener("online", this.handleConnectionChange, true);
    window.removeEventListener("offline", this.handleConnectionChange, true);

    document.removeEventListener("new-message", (e) => {
      this.parseNewConversationDataReceivedFromPusher(e.detail, false); 
    }, true);

    document.removeEventListener("new-message-via-agent-routing", (e) => {
      this.parseNewConversationDataReceivedFromPusher(e.detail, true);
    }, true);

    document.removeEventListener("customer_info_update", (e) => {
      this.updateCustomerMarketingOptinStatusHandler(e.detail);
    }, true);
  },
  computed: {
    isDarkMode() { return useUIStore().isDarkMode; },
    isLoading() { return useUIStore().isLoading; },
    getShopLogoImage() { return _getShopLogoImage(useAuthStore().cleanUserData); },
    uploadFileType() {
      if(this.uploadedURLData.mime_type?.includes('image')) return 'image';
      else if(this.uploadedURLData.mime_type?.includes('video')) return 'video';
      return 'document';
    },
    isBrowserPlayableVideo() {
      return isBrowserPlayableMimeType(this.uploadedURLData?.mime_type);
    },
    agentAssigned() {
      return this.activeUserConversationDataResult &&
        this.activeUserConversationDataResult.length &&
        this.activeUserConversationDataResult[0].agent &&
        this.activeUserConversationDataResult[0].agent.id
        ? this.activeUserConversationDataResult[0].agent.id
        : "not_assigned";
    },
    mentionAgentOptions() {
      return this.allAgentsResult.map((e) => { return { text: e.name + "  [" + e.email + "]", handler: () => this.mentionAgent(e), }; });
    },
    productActionOptions() {
      const returnArray = [];

      if (this.activeCustomer.channel === "whatsapp" && this.whatsappConnected) {
        returnArray.push({
          text: "Send location",
          icon: this.locationOutline,
          handler: () => {
            this.runAfterActionSheetClosed(() => {
              this.sendLocationModal = true;
            });
          },
        }, {
          text: "Send contact",
          icon: this.callOutline,
          handler: () => {
            this.runAfterActionSheetClosed(() => {
              this.sendContactModal = true;
            });
          },
        }, {
          text: "Send message template",
          icon: this.mailOutline,
          handler: () => {
            this.runAfterActionSheetClosed(async () => {
              this.sendWhatsappTemplate = true;
              this.fetchTemplates();
            });
          },
        });
      }

      return returnArray;
    }, 
    filteredShortcutOptions() {
      const term = this.shortcutSearch.trim().toLowerCase();
      // Remove leading slash if user types it (e.g. /createorder → createorder)
      const normalizedTerm = term.startsWith('/') ? term.slice(1) : term;
      return this.allShortcuts.filter(option =>
        option.name.toLowerCase().includes(normalizedTerm)
      );
    },
    checkIfToShow_inputContainerInnerInline() {
      if (!this.activeCustomer) return false;
      if (this.activeCustomer.channel === "whatsapp" && (this.isWhatsappChat_old24H || this.isWhatsappChat_sendTemplate)) return false; //WA send template mode is active
      return true
    },
    chatPlaceholder(){
      const isMobile = window.innerWidth <= 768;
      const placeholders = {
        note: 'Send an internal note',
        mobile: 'Type a message',
        desktop: 'Type message (Shift+Enter for new line, Ctrl+/ for shortcuts)',
      };

      if (this.noteMode) {
        return placeholders.note;
      }

      return isMobile ? placeholders.mobile : placeholders.desktop;
    },
    supportedImageTypes() {
      if(this.activeCustomer.channel === 'googlercs') {
        return '(.jpg, .png, or .gif only)'
      } else {
        return '(.jpg, .png only)'
      } 
    },
    supportedFiles() {
      if(this.activeCustomer.channel === 'googlercs') {
        return '(.pdf only)'
      } else {
        return '(.pdf, .doc, .docx, .xls, .ppt, .pptx or .txt only)'
      } 
    },
    getMaxLengthForChannels() {
      if(this.activeCustomer.platform === 'sms') {
        return 1000
      } else if(this.activeCustomer.channel === 'whatsapp') {
        return 4000
      } else if(this.activeCustomer.channel === 'googlercs') {
        return 3000
      } else {
        return 1000
      }
    }
  },
  watch: {
    conversationid(newVal) {
      if (newVal !== undefined) this.init();
      else this.receiverDetailMode = false;
      this.newChatMessage = undefined;
    },
    async selectedReassignGroup(nVal) {
      if (nVal === undefined) {
        this.allAgentsOfSelectedGroupResult = [];
        this.allAgentsResult_apiBased_data = [];
        this.searchAgentToReassignText = "";
        return;
      }
      try {
        this.loadingRoles = true;
        this.searchAgentToReassignText = "";
        this.allAgentsResult_apiBased_data = [];
        this.allAgentsOfSelectedGroupResult = [];
        const params = {
          businessroleid: nVal,
        };
        var rolesResponse = await apiInterceptor.get( environment("VUE_APP_API_URL") + "livechat/v1/core/agents", { params } );
        this.allAgentsOfSelectedGroupResult = rolesResponse;
      } catch (error) {
        useUIStore().updateToast({ open: true, message: error.message || "Something went wrong!", type: "danger" });
      } finally {
        this.loadingRoles = false;
      }
    }
  },
  methods: {
    removeNegativeSign, getNameInitials, calculate24Plus1RuleForCustomer, renderDateTime_lastReplyTimestamp, renderNormalChat,
    checkIfThereIsNoLogoThenShowTransparentImage, renderCustomerImage_style_background,
    runAfterActionSheetClosed(callback) {
      this.actionModal = false;
      // Wait for dismiss animation so the next overlay can receive pointer events.
      setTimeout(() => {
        callback();
      }, 250);
    },
    disabling_rightClick_for_privacy_of_content() {
      setTimeout(() => {
        var image_component_elems = document.getElementsByClassName('.image_component');
        for (var cm1 = 0; cm1 < image_component_elems.length; cm1++) {
          image_component_elems[cm1].addEventListener('contextmenu', e => e.preventDefault());
        }
        var video_component_elems = document.getElementsByClassName('.video_component');
        for (var cm2 = 0; cm2 < video_component_elems.length; cm2++) {
          video_component_elems[cm2].addEventListener('contextmenu', e => e.preventDefault());
        }
      }, 50);
    },
    playUnreadMessageSound() {
      const audio = document.getElementById("customerUnReadMessagesAudio");
      if (audio && typeof audio.play === "function") {
        const playPromise = audio.play();
        if (playPromise && typeof playPromise.catch === "function") {
          playPromise.catch(() => {});
        }
      }
      const event = new CustomEvent("pingingLiveChat");
      document.dispatchEvent(event);
    },
    async parseNewConversationDataReceivedFromPusher(data,comingViaAgentRouting){
      if(comingViaAgentRouting != true){
        comingViaAgentRouting = false;
      }

      if(typeof data.conversation_active != 'undefined'){
        if(data.conversation_active == null){
          data.conversation_active = true;
        }
      }

      //Note: using "this.$route.query.conversation" instead of "this.activeCustomer.id"
      if(data.conversationid == this.$route.query.conversation){
        
        if(["whatsapp"].includes(data.platform) && data.replied == false) {
          this.isWhatsappChat_old24H = false;
          this.isWhatsappChat_sendTemplate = false;
          this.activeCustomer.userReplyTimestamp = data.created;
        }

        this.activeUserConversationDataResult.unshift.apply(this.activeUserConversationDataResult, [data]);

        this.disabling_rightClick_for_privacy_of_content();
      // commented this for pusher related issues and duplication of code in livechathome.vue
                
        var result = {
          conversation: data
        };
        
        if(typeof result.conversation.active != 'undefined'){
          if(result.conversation.active == null){
            result.conversation.active = true;
          }
        }
        else if(typeof data.conversation_active != 'undefined'){
          result.conversation.active = data.conversation_active;
        }
        else if(typeof data.active != 'undefined'){
          result.conversation.active = data.active;
        }
        
          //console.info('new coming chat...SCC');
          result.conversation.id = result.conversation.conversationid;
          result.conversation.currentlyOpendChat = false;

          result.conversation.channel_id = data.pageid;
          result.conversation.channel = this.getChannelFromPageActive(data.pageid); 
          result.conversation.lastReplyTimestamp = data.created;
          result.conversation.userReplyTimestamp = data.created;  

          if((this.calculate24Plus1RuleForCustomer(data.created) >= 24) || (this.calculate24Plus1RuleForCustomer(data.created) >= 24 && result.conversation.channel == 'whatsapp')){
            result.conversation.page_msg_subscription_restriction = true;
          }
          else{
            result.conversation.page_msg_subscription_restriction = false;

            if(result.conversation.channel == 'whatsapp' && data.replied == false){
              this.isWhatsappChat_old24H = false;
              this.isWhatsappChat_sendTemplate = false;
            }
          }

          if(typeof data.agent != 'undefined' && data.agent != null){
            result.conversation.assigned_to = data.agent;
          }
          
          if(result.conversation.platform != 'undefined' && result.conversation.platform != '' && result.conversation.platform != null) {
            this.activeCustomer = result.conversation;
            this.activeCustomer.channel = result.conversation.platform;
          }
          if (result.conversation.active == true || (result.conversation.active == false && result.conversation.assigned_to == null)) {
            this.playUnreadMessageSound();
          }
          await this.markAsReadConversation(data.conversationid);
      }
    },
    async updateCustomerMarketingOptinStatusHandler(e) {
      if(this.activeCustomer.conversationid == e.conversation_id){
        this.activeCustomer.marketing_opt_in_state = e.marketing_opt_in_status;

        for(var i = 0; i < this.activeCustomer.all_platforms.length; i++){
          if(this.activeCustomer.all_platforms[i].conversation_key === e.conversation_id){
            this.activeCustomer.all_platforms[i].marketing_opt_in_state = e.marketing_opt_in_status;
          }
        }
      }
    },
    handleConnectionChange(event) {
      if (event.type == "online") {
        useUIStore().updateLoading({ isLoading: true, message: 'Reconnecting...' });
        this.init();
      }
    },
    newMessageKeyPressHandler(event) {
      if(event) {
        const isCtrlSlash = event.ctrlKey && event.code === "Slash";
        switch(event.key) {
          case "Enter": {
            if(!event.shiftKey && window.innerWidth > 600) {
              event.preventDefault();
              if (this.noteMode) this.sendNote();
              else {
                if (this.activeCustomer.assigned_to != null && this.activeCustomer.assigned_to.id != this.roleDetails.id) {
                  this.confirmTakeoverChatFromOtherAgent = true;
                  this.taskToBeDone_after_confirmTakeoverChatFromOtherAgent = "sendMessageFinal";
                } else this.sendMessageFinal();
              }
            }
          } break;
          case "@": {
            if(this.noteMode) this.mentionAgentMode = true;
          } break;
          case "/": {
            break;
          }
        }

        if (isCtrlSlash && this.allShortcuts.length) {
          this.sendShortcutMode = true;
        }
      }
    },
    toggleCustomerDetails(){
      this.receiverDetailMode = !this.receiverDetailMode;
    },
    async init(status) {
      // Guard against a missing/invalid conversation id so we never build
      // an invalid URL like crm/v1/customers/undefined [APICC-3238].
      if (!this.conversationid || this.conversationid === 'undefined') {
        this.receiverDetailMode = false;
        useUIStore().updateLoading({ isLoading: false });
        return;
      }
      try {
        switch (status) {
          case 'userData':
            this.receiverDetailMode = false;
            if (this.conversationid) {
              this.$router.go({ path: "/page-inbox", query: { conversation: this.conversationid } });
            } else {
              this.$router.go({ path: "/page-inbox", query: null });
            }
            break;
          case 'resolvedChat':
            this.receiverDetailMode = false;
            this.$emit('resolved_chat_init');
        }
        useUIStore().updateLoading({ isLoading: true, message: 'Loading conversation...' });
        this.activeUserConversationDataResult = [];
        this.agentReAssignmentAllowed = true;
        this.actionsPanelEnabled = true;

        let inboxResponse = apiInterceptor.get( environment("VUE_APP_API_URL") + "livechat/v1/core/chats/" + this.conversationid );
        let receiverResponse = apiInterceptor.get( environment("VUE_APP_API_URL") + "crm/v1/customers/" + this.conversationid );

        let [inboxRes, receiverRes, agentsData, shortcutsRes, businessRolesRes] = await Promise.all([
          inboxResponse,
          receiverResponse,
          queryClient.ensureQueryData(teamMembersQueryOptions),
          queryClient.ensureQueryData(livechatShortcutsQueryOptions),
          queryClient.ensureQueryData(livechatBusinessRolesQueryOptions),
        ]);
        inboxResponse = inboxRes;
        receiverResponse = receiverRes;
        // recentUploadedFilesResponse = allResponses[5];
        this.fetchInboxResponseHandler(inboxResponse);
          if (typeof receiverResponse.data.active != "undefined") {
            if (receiverResponse.data.active == null) {
              receiverResponse.data.active = true;
            }
          }

          var thisCustomer = receiverResponse.data;
          thisCustomer.id = this.conversationid;
          thisCustomer.conversationid = this.conversationid; 
          thisCustomer.currentlyOpendChat = false;
          if (typeof thisCustomer.outletid != "undefined") {
            this.activeCustomer_outletid = thisCustomer.outletid;
          } else {
            this.activeCustomer_outletid = undefined;
          }

          thisCustomer.channel_id = thisCustomer.channel;
          thisCustomer.channel = this.getChannelFromPageActive(
            thisCustomer.channel,
            true
          );

          this.activeCustomer = thisCustomer; //doing it here also just to add data in activeCustomer

          this.pageid = this.activeCustomer?.pageid;
          this.page_conversation_id = this.activeCustomer?.page_conversation_id;
          this.platform = this.activeCustomer?.platform;

          if (this.platform == "" || this.platform == null) {
            this.platform = this.activeCustomer?.channel;
          }

          if (
            this.calculate24Plus1RuleForCustomer(
              thisCustomer.userReplyTimestamp
            ) >= 24
          ) {
            thisCustomer.page_msg_subscription_restriction = false;
          } else {
            thisCustomer.page_msg_subscription_restriction = false;
          }

          if (this.calculate24Plus1RuleForCustomer(thisCustomer.userReplyTimestamp) >= 24 && thisCustomer.channel == "whatsapp") {
            this.isWhatsappChat_old24H = true;
            if(this.activeUserConversationDataResult.length === 0) this.toggleSendTemplateForWA();
          } else {
            if (thisCustomer.channel == "whatsapp") {
              this.isWhatsappChat_old24H = false;
              this.isWhatsappChat_sendTemplate = false;
              if(this.activeUserConversationDataResult.length === 0) this.toggleSendTemplateForWA();
            }
          }

          //---

          if (thisCustomer.channel == "INVALID_MERCHANT") {
            //this.fetchCustomers(0,true); //pending
          } else {

            useUIStore().updateLoading({ isLoading: false });

            this.activeCustomer = thisCustomer;

            this.resetTemplateDataForWA();

            if (typeof thisCustomer.outletid != "undefined") {
              this.activeCustomer_outletid = thisCustomer.outletid;
            } else {
              this.activeCustomer_outletid = undefined;
            }

            this.activeCustomer.currentlyOpendChat = true;

            if (this.activeCustomer.channel == "whatsapp") {
              if (this.calculate24Plus1RuleForCustomer(this.activeCustomer.userReplyTimestamp) >= 24) {
                this.isWhatsappChat_old24H = true;
              }
              if(this.activeUserConversationDataResult.length === 0) this.toggleSendTemplateForWA();
            }

            //this.fetchActiveConversationData(this.conversationid);

            this.singleCustomerPastAgentsResultApiCalled = false;
            this.singleCustomerPastAgentsResult = [];
            this.noteMode = false;
          }
          if(!agentsData?.length) {
            agentsData = [];
          }
        
        if (agentsData.length) {
          this.allAgentsResult = [];

          for (
            var i_roles = 0;
            i_roles < agentsData.length;
            i_roles++
          ) {
            for (var key_role in agentsData[i_roles]
              .permissions) {
              if (
                key_role == "page_inbox" &&
                agentsData[i_roles].permissions[key_role] == true
              ) {
                this.allAgentsResult.push(agentsData[i_roles]);
              }
            }
          }
        } else {
          console.error("Response:", agentsData);
        }
        
        if (shortcutsRes) this.allShortcuts = shortcutsRes.shortcuts;
        else console.error("Response:", shortcutsRes);

        if (businessRolesRes) this.allGroupsResult = businessRolesRes.business_roles;
        else console.error("Response:", businessRolesRes);
        
        // if (recentUploadedFilesResponse && (recentUploadedFilesResponse.status == 200 || recentUploadedFilesResponse.status == 201) && recentUploadedFilesResponse.data && recentUploadedFilesResponse.data.success) {
        //   recentUploadedFilesResponseData = recentUploadedFilesResponse.data;
        //   await this.Storage.set({
        //     key: "jmpr_whatsapp-list-uploaded-document",
        //     value: JSON.stringify(recentUploadedFilesResponseData),
        //   });
        // }
        // if (recentUploadedFilesResponseData) this.recentUploadedFiles = recentUploadedFilesResponseData.images;
        // else console.error("Response:", recentUploadedFilesResponseData);

      } catch (error) {
        console.error("Exception", error);
      } finally {
        useUIStore().updateLoading({ isLoading: false });
        this.scrollToBottom();
      }
    },
    async loadMoreMessages() {
      this.loadMoreChatLoadingShow = true;
      try {
        let reqBody = {
          conversationid: this.conversationid,
          cursor: this.activeUserConversationCursor,
        };
        const params = {
          ...reqBody
        }
        let inboxResponse = await apiInterceptor.get( environment("VUE_APP_API_URL") + "livechat/v1/core/chats/" + this.conversationid, { params } );
        this.fetchInboxResponseHandler(inboxResponse);
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message || "Something went wrong!",
          type: "danger",
        });
      }
    },
    fetchInboxResponseHandler(data) {
      useUIStore().updateLoading({ isLoading: false });

      if (typeof this.activeUserConversationCursor != "undefined") {
        var newData = data.messages;
        console.log("newData", newData);
        this.activeUserConversationDataResult.push.apply(
          this.activeUserConversationDataResult,
          newData
        );
        this.loadMoreChatLoadingShow = false;
      } else {
        this.activeUserConversationDataResult = [];

        this.activeUserConversationDataResult = data.messages;
      }

      this.activeUserConversationCursor = data.cursor;
      this.activeUserConversationMore = data.more;

      this.disabling_rightClick_for_privacy_of_content();
    },
    searchAgentToReassignTextChanger() {
      useUIStore().updateLoading({ isLoading: false });
      setTimeout(() => {
        var searchKeyword = this.searchAgentToReassignText;

        if (typeof searchKeyword != "undefined" && searchKeyword != null) {
          if (searchKeyword == "" || searchKeyword.length <= 2) {
            this.allAgentsResult_apiBased_data = [];
          } else if (searchKeyword.length > 2) {
            this.allAgentsResult_apiBased_data = [];

            const keyword = searchKeyword.toLowerCase();
            const agentPool = this.selectedReassignGroup !== undefined && this.allAgentsOfSelectedGroupResult.length
              ? this.allAgentsOfSelectedGroupResult
              : this.allAgentsResult;

            this.allAgentsResult_apiBased_data = agentPool.filter(agent =>
              agent.name.toLowerCase().indexOf(keyword) > -1 ||
              agent.email.toLowerCase().indexOf(keyword) > -1
            );
          }
        }
      }, 10);
    },
    sendMessage() {
      if (this.activeCustomer.assigned_to != null && this.activeCustomer.assigned_to.id != this.roleDetails.id) {
        this.confirmTakeoverChatFromOtherAgent = true;
        this.taskToBeDone_after_confirmTakeoverChatFromOtherAgent = "sendMessageFinal";
      } else this.sendMessageFinal();
    },
    async sendMessageFinal() {
      if(this.noteMode) this.sendNote();
      else {
        if (this.newChatMessage && this.newChatMessage.length) {
          try {
            useUIStore().updateLoading({ isLoading: true });
            let reqBody = {
              conversationid: this.conversationid,
              message: this.newChatMessage,
              page_conversation_id: this.page_conversation_id,
              pageid: this.pageid,
              platform: this.platform,
            };
            this.newChatMessage = undefined;
            await apiInterceptor.post( environment("VUE_APP_API_URL") + "social/v1/manual-message", reqBody );
          } catch (error) {
            useUIStore().updateToast({
              open: true,
              message: error.message || "Something went wrong!",
              type: "danger",
            });
          } finally {
            useUIStore().updateLoading({ isLoading: false });
            this.$nextTick(() => {
              document.getElementById('newLiveChatMessage')?.focus();
              this.scrollToBottom();
            })
          }
        } else {
          useUIStore().updateToast({
              open: true,
              message: 'Please enter the message and try again!',
              type: "danger",
            });
        }
      }
    },
    async sendNote() {
      try {
        let reqBody = {
          conversation: this.conversationid,
          message: this.newChatMessage,
          agent: this.agentAssigned,
        };
        this.newChatMessage = undefined;
        await apiInterceptor.post( environment("VUE_APP_API_URL") + "social/v1/assign-note", reqBody );
        this.scrollToBottom();
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message || "Something went wrong!",
          type: "danger",
        });
      } finally {
        this.noteMode = false;
      }
    },
    sendShortcut(message) {
      this.newChatMessage = message;
      this.sendShortcutMode = false;
      let newLiveChatMessage = document.getElementById('newLiveChatMessage');
      newLiveChatMessage.focus();
    },
    scrollModel(){
      const addTemplateDiv = document.getElementById("templatePreview");
      addTemplateDiv.scrollIntoView({ behavior: "smooth" });
    },
    mentionAgent(a) {
      this.newChatMessage = (this.newChatMessage && this.newChatMessage.length ? this.newChatMessage : "") + a.name;
      this.mentionAgentMode = false;
    },
    changeChatInput(prop) {
      this.newChatMessage = prop;
    },
    openAttachmentModal() {
      this.waitForconfirmation = false;
      this.attachAndSendModal = true;
    },
    getUploadedURLData(urlData) {
      this.waitForconfirmation = true;
      this.uploadedURLData = urlData[0];
      this.videoPlaybackError = false;
    },
    handleUrlUpload(urlData) {
      this.sentViaURL = true;
      this.waitForconfirmation = true;
      this.uploadedURLData = urlData;
      this.videoPlaybackError = false;
    },
    async confirmSendAttachment() {
      this.sendingFileMessage  = true;
      this.waitForconfirmation = false;
      await this.addProductMediaUrl(this.uploadedURLData.file_url, this.uploadFileType);
      this.sendingFileMessage = false;
      this.waitForconfirmation = true;
      this.chatInputBarLoadingIsOn = false;
      this.attachAndSendModal = false;
      this.uploadedURLData = {
        filename: undefined,
        file_name: undefined,
        file_url: '',
        mime_type: undefined
      };
    },
    async addProductMediaUrl(media_url, mediaType) {
      try {        
        if (!media_url) {
          useUIStore().updateToast({
            open: true,
            message: `The uploaded ${mediaType} is invalid`,
            type: "danger",
          });
          this.chatInputBarLoadingIsOn = false;
          return;
        }
        let reqBody = {
          message: media_url,
          conversationid: this.conversationid,
          page_conversation_id: this.page_conversation_id,
          pageid: this.pageid,
          platform: this.platform,
        };

        switch (mediaType) {
          case 'image':
            reqBody.messagetype = "image";
            break;
          case 'video':
            reqBody.messagetype = "videolink";
            reqBody.url = media_url;
            reqBody.thumb_url = '@/resources/images/video_placeholder.png';
            reqBody.filetype = "video";
            break;
          case 'document':
            reqBody.messagetype = "document";
            reqBody.filetype = "document";
            break;
        }
        if (this.sentViaURL) {
          reqBody.name = media_url.split('/').pop();
        }
        await apiInterceptor.post( environment("VUE_APP_API_URL") + "social/v1/manual-message", reqBody );
        this.recentUploadedFiles.unshift({
          id: Math.floor(Math.random() * 100000000000 + 1),
          extension: media_url.split('.').pop().toLowerCase(),
          name: media_url.split('/').pop(),
          url: media_url,
        });
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message || "Something went wrong",
          type: "danger",
        });
        this.chatInputBarLoadingIsOn = false;
      } finally {
        this.sentViaURL = false;
      }
    },
    switchNoteMode() {
      this.noteMode = !this.noteMode;
    },
    async assignChat(type, id) {
      useUIStore().updateLoading({ isLoading: true, message: 'Assigning...' });
      let reqBody = {
        conversation_id: this.conversationid,
      };
      if (type === "group") {
        reqBody["businessrole_id"] = id;
      } else {
        reqBody["agent_id"] = id;
      }
      try {
        await apiInterceptor.post( environment("VUE_APP_API_URL") + "roles/v1/routing/assign", reqBody );
        this.toggleCustomerDetails();
        useUIStore().updateToast({
          open: true,
          message: "Assignment Successful",
          type: "success",
        });
        this.init();
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message,
          type: "danger",
        });
      } finally {
        useUIStore().updateLoading({ isLoading: false });
        this.reAssignModal = false;
      }
    },
    sendTemplateAlert(){
      if (this.activeCustomer.assigned_to != null && this.activeCustomer.assigned_to.id != this.roleDetails.id) {
        this.confirmTakeoverChatFromOtherAgent = true;
        this.taskToBeDone_after_confirmTakeoverChatFromOtherAgent = "sendMessageTemplate";
      } else this.sendTemplate();
    },
    async sendTemplate() {
      this.commonLoader = true;
      try {
        const isWaValid_Template = this.$refs.whatsAppMessageTemplate.isValidToSubmit();
        if (!isWaValid_Template) {
          return;
        }
        const { waTemplateId: waTemplateId_A, message_params: message_params_A, custom_messages } = this.$refs.whatsAppMessageTemplate.getBroadcastMessageParamsToSave(); // generate_wa_message_params
        let reqBody = {
          conversationid: this.conversationid,
          page_conversation_id: this.page_conversation_id,
          pageid: this.pageid,
          platform: this.platform,
          message: `s3ndt3mpl4te_${waTemplateId_A}`,
          messagetype: "template",
          message_params: message_params_A,
          custom_messages
        };
        await apiInterceptor.post( environment("VUE_APP_API_URL") + "social/v1/manual-message", reqBody );
        this.scrollToBottom();
        this.resetTemplateDataForWA();
        if (this.activeCustomer.channel == "whatsapp") {
          if (this.calculate24Plus1RuleForCustomer(this.activeCustomer.userReplyTimestamp) >= 24) {
            this.isWhatsappChat_old24H = true;
          }
          if(this.activeUserConversationDataResult.length === 0) this.toggleSendTemplateForWA();
        }
        this.sendWhatsappTemplate = false;
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message || "Something went wrong",
          type: "danger",
        });
      } finally {
        this.commonLoader = false;
      }
    },
    fillLocations(locationForm) {
      this.sendLocationLatitudeText = locationForm.sendLocationLatitudeText;
      this.sendLocationLongitudeText = locationForm.sendLocationLongitudeText;
    },
    sendLocationTemplate() {
      let formError = false;
      let name = this.sendLocation.buttonTitle;
      let addressname = this.sendLocation.address;
      let latitude = this.sendLocationLatitudeText;
      let longitude = this.sendLocationLongitudeText;

      if (name === undefined || addressname === undefined) {
        formError = true;
        useUIStore().updateToast({
          open: true,
          message: "Please fill in the required fields!",
          type: "danger",
        });
      } else if (latitude === undefined || longitude === undefined) {
        formError = true;
        useUIStore().updateToast({
          open: true,
          message: "Please provide latitude & longitude!",
          type: "danger",
        });
      }

      if (formError == false) {
        this.commonLoader = true;
        let reqBody = {
          conversationid: this.conversationid,
          page_conversation_id: this.page_conversation_id,
          pageid: this.pageid,
          platform: this.platform,
          message: "",
          messagetype: "location",
          name: name,
          addressname: addressname,
          latitude: latitude,
          longitude: longitude,
        };
        this.newChatMessage = undefined;
        apiInterceptor.post( environment("VUE_APP_API_URL") + "social/v1/manual-message", reqBody ).then(() => {
          this.scrollToBottom();
          useUIStore().updateToast({
            open: true,
            message: "Location has been sent successfully!",
            type: "success",
          });
        }).catch((error) => {
          this.commonLoader = false;
          useUIStore().updateToast({
            open: true,
            message: error.message || "Something went wrong",
            type: "danger",
          });
        }).finally(() => {
          useUIStore().updateLoading({ isLoading: false });
          this.commonLoader = false;
          this.sendLocationModal = false;
          this.sendLocation = {
            buttonTitle: undefined,
            address: undefined,
          };
          this.sendLocationLatitudeText = undefined;
          this.sendLocationLongitudeText = undefined;
        });
      }
    },
    async sendContactTemplate() {
      let formError = false;
      if(!this.sendContact.name || this.sendContact.name.length === 0) return useUIStore().updateToast({ open: true, message: "Please enter Contact name", type: "warning" });
      if(!this.sendContact.countryCode || this.sendContact.countryCode == undefined || this.sendContact.countryCode == '') return useUIStore().updateToast({ open: true, message: "Please select country code", type: "warning" });
      if(!this.sendContact.number || this.sendContact.number.length < 0 || this.sendContact.number.length == 0) return useUIStore().updateToast({ open: true, message: "Please enter the correct mobile number", type: "warning" });
      let name = this.sendContact.name;
      let number = this.sendContact.number;
      let countryCode = this.sendContact.countryCode;
      if (name === undefined || number === undefined || number.length < 0) {
        formError = true;
        useUIStore().updateToast({
          open: true,
          message: "Please fill in the required fields!",
          type: "danger",
        });
      }
      if (formError == false) {
        try {
          this.commonLoader = true;
          let reqBody = {
            conversationid: this.conversationid,
            page_conversation_id: this.page_conversation_id,
            pageid: this.pageid,
            platform: this.platform,
            message: "",
            messagetype: "contact",
            name: name,
            phone: countryCode + number,
          };
          this.newChatMessage = undefined;
          await apiInterceptor.post( environment("VUE_APP_API_URL") + "social/v1/manual-message", reqBody );
          this.scrollToBottom();
          useUIStore().updateToast({
            open: true,
            message: "Contact has been sent successfully!",
            type: "success",
          });
        } catch (error) {
          useUIStore().updateToast({
            open: true,
            message: error.message || "Something went wrong",
            type: "danger",
          });
        } finally {
          this.commonLoader = false;
          (this.sendContactModal = false),
            (this.sendContact = {
              title: undefined,
              number: undefined,
              countrycode: undefined
            });
        }
      }
    },
    resetTemplateDataForWA() {
      if (this.activeCustomer.channel == "whatsapp") {
        if (this.calculate24Plus1RuleForCustomer(this.activeCustomer.userReplyTimestamp) >= 24) {
          this.isWhatsappChat_old24H = true;
        } else {
          this.isWhatsappChat_old24H = false;
        }
      }
      this.isWhatsappChat_sendTemplate = false;
      this.isWhatsappSendTemplateEnabled = false;
    },
    toggleSendTemplateForWA() {
      this.isWhatsappChat_sendTemplate = true;
      this.enableWhatsappTemplating();
    },
    enableWhatsappTemplating() {
      this.isWhatsappSendTemplateEnabled = true;
    },
    disableWhatsappTemplating() {
      this.isWhatsappSendTemplateEnabled = false;
      this.isWhatsappChat_sendTemplate = false;
    },
    async selectRecentUploadFile(file) {
      try {
        this.waitForconfirmation = false;
        this.sendingFileMessage = true;
        let reqBody = {
          conversationid: this.conversationid,
          page_conversation_id: this.page_conversation_id,
          pageid: this.pageid,
          platform: this.platform,
          message: file.url,
          messagetype: undefined,
          filetype: undefined,
          extension: file.extension,
          contenttype: file.contenttype,
          name: file.name,
        };
        let ext = file.extension.toLowerCase();
        if (
          ext.indexOf("png") > -1 ||
          ext.indexOf("jpg") > -1 ||
          ext.indexOf("jpeg") > -1 ||
          ext.indexOf("gif") > -1 ||
          ext.indexOf("svg") > -1
        ) {
          reqBody["messagetype"] = "image";
          reqBody["filetype"] = "image";
        } else if (
          ext.indexOf("mp4") > -1 ||
          ext.indexOf("mpeg") > -1 ||
          ext.indexOf("mpeg4") > -1
        ) {
          reqBody["messagetype"] = "videolink";
          reqBody["filetype"] = "video";
        } else {
          reqBody["messagetype"] = "document";
          reqBody["filetype"] = "document";
        }
        this.newChatMessage = undefined;
        await apiInterceptor.post( environment("VUE_APP_API_URL") + "social/v1/manual-message", reqBody );
        this.scrollToBottom();
        useUIStore().updateToast({
          open: true,
          message: "File has been sent to customer successfully!",
          type: "success",
        });
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message || "Something went wrong",
          type: "danger",
        });
      } finally {
        this.attachAndSendModal = false;
        this.waitForconfirmation = true;
        this.sendingFileMessage = false;
      }
    },
    async setAgentReminder(){
      this.settingUpReminder = true;
      try {
        var agentReminderMessageText = this.sendReminderNote;
        var agentReminderTimeText = this.customTime;
        var agentReminderTimeFormatDDL = this.timeFormatOptions;
        var agentReminderDateTimeTypeSelector = this.reminderValue;

        var datetimeNow = new Date();

        if(agentReminderDateTimeTypeSelector == 'custom') {
          var interval = agentReminderTimeFormatDDL;
        }
        else {
          if(agentReminderDateTimeTypeSelector == '1-hours'){
            interval = "hours";
            agentReminderTimeText = "1";
          }
          else if(agentReminderDateTimeTypeSelector == '2-hours'){
            interval = "hours";
            agentReminderTimeText = "2";
          }
          else if(agentReminderDateTimeTypeSelector == '1-days'){
            interval = "days";
            agentReminderTimeText = "1";
          }
          else if(agentReminderDateTimeTypeSelector == '2-days'){
            interval = "days";
            agentReminderTimeText = "2";
          }
          else if(agentReminderDateTimeTypeSelector == '7-days'){
            interval = "days";
            agentReminderTimeText = "7";
          }
        }

        if(interval == 'minutes'){
          datetimeNow.setMinutes(datetimeNow.getMinutes() + parseInt(agentReminderTimeText));
        }
        else if(interval == 'hours'){
          datetimeNow.setHours(datetimeNow.getHours() + parseInt(agentReminderTimeText));
        }
        else if(interval == 'days'){
          datetimeNow.setDate(datetimeNow.getDate() + parseInt(agentReminderTimeText));
        }

        let datetimeNowFormatted = datetimeNow.getDate() +"-"+ (datetimeNow.getMonth() + 1) +"-"+ datetimeNow.getFullYear() +" "+ datetimeNow.getHours() +":"+ datetimeNow.getMinutes();

        let reqBody = {
          message: agentReminderMessageText,
          message_type: "schedule",
          interval: interval,
          schedule: agentReminderTimeText,
          scheduled_time: datetimeNowFormatted,
          agent: this.activeCustomer.assigned_to.id
        };
        let conversationid = this.conversationid; 
        await apiInterceptor.post( environment("VUE_APP_API_URL") + "livechat/v1/core/chats/" + conversationid + '/reminder', reqBody );
        useUIStore().updateToast({
          open: true,
          message: 'Reminder has been set successfully!',
          type: "success",
        });
        this.scrollToBottom();
        this.customTime = '';
        this.sendReminderNote = '';
        this.sendReminderModel = false;
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message || "Something went wrong!",
          type: "danger",
        });
        useUIStore().updateLoading({ isLoading: false });
      } finally {
        this.settingUpReminder = false;
        this.sendReminderModel = false;
      }
    },
    statusMessage(result) {
      switch (result.status) {
        case 'sent':
          return 'Message sent';
        case 'submitted':
          return 'Message submitted';
        case 'delivered':
          return 'Message delivered';
        case 'read':
          return 'Message read';
        case 'rejected':
          if (!result.delivered) {
            if (result.fail_reason && result.fail_reason !== '' && result.fail_reason !== 'None' && result.fail_reason !== null) {
              return result.fail_reason;
            } else {
              return 'Message rejected'; // Fallback message
            }
          }
          return '';
        default:
          return '';
      }
    },
    statusIcon(result) {
      return result.status === 'sent' ? this.checkmarkOutline : ['submitted', 'delivered', 'read'].includes(result.status) ? this.checkmarkDoneOutline : (result.status === 'rejected' && !result.delivered) ? this.banOutline : '';
    },
    statusIconColor(result) {
      return (['sent', 'submitted', 'delivered'].includes(result.status)) ? 'medium' : '';
    },
    undeliveredMessage(result) {
      if (!['', 'None'].includes(result.fail_reason)) {
        return result.fail_reason;
      } else {
        return "Message not delivered - we are waiting for a reply from the user to engage.";
      }
    },
    async markAsReadConversation(id) {
      try {
        const params = {
          conversation_id: id,
        };
        await apiInterceptor.patch( environment("VUE_APP_API_URL") + "livechat/v1/core/chats/" + id + '/mark_read',  { params } );
      } catch (error) {
        console.error("Exception", error);
      }
    },
    async fetchTemplates() {
      try {
        // Always fetch fresh — staleTime:0 bypasses the 5-min cache so opening
        // the modal after navigating away (which can leave a stale/aborted cache
        // entry) always triggers a real API call.
        const response = await queryClient.fetchQuery({
          ...whatsappTemplatesQueryOptions(this.whatsAppSocialData.id, { size: '-1' }),
          staleTime: 0,
        });
        this.allTemplates = (response.templates || []).filter(
          (objTemplate) => objTemplate && objTemplate?.status === 'APPROVED'
        );
        this.allTemplates.sort((a, b) => a.template_name.localeCompare(b.template_name));
      } catch (error) {
        useUIStore().updateToast({ open: true, message: "Something went wrong", type: "danger" })
      }
    },
    async stopCurrentFlow(){
      useUIStore().updateLoading({ isLoading: true, message: 'Stopping current flow...' });
      try {
        let reqBody = {
          conversationid: this.conversationid,
          page_conversation_id: this.page_conversation_id,
          pageid: this.pageid,
          platform: this.platform,
          hashtag: "807pl3453c@nc317h3ch@7"
        };        
        await apiInterceptor.post(environment("VUE_APP_API_URL") + "social/v1/bot-takeover", reqBody );
        useUIStore().updateToast({
          open: true,
          message: 'The current flow of this customer has been stopped successfully.',
          type: "success",
        });
        
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message || "Something went wrong",
          type: "danger",
        });
      } finally {
        useUIStore().updateLoading({ isLoading: false });
        this.confirmStopCurrentFlowModal = false;
        this.init();
      }
    },
  }
};
</script>

<style scoped>
.single-customer-chat {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.single-customer-chat-page {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  overflow: hidden;
  position: relative;
}

.ellipsisVerticalImage{
  color: var(--purple);
}
.noteMessageType{
  background-color: var(--purple-opac) !important;
}
.info-box{
  display: flex;
  align-items: center;
  flex-direction: row;
  background: var(--purple-opac);
  padding: 10px;
  border-radius: 5px;
}
.info-text{
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: var(--black);
  margin-left: 8px;
}
.agent-img-container{
  width: 45px;
  height: 45px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
}
.agent-img-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.action-items {
  --background: var(--background-primary);
  border-radius: 5px;
  cursor: pointer;
  --inner-padding-top: 10px;
  margin-bottom: 5px;
  --inner-padding-bottom: 10px;
}
.productListItems{
  max-height: 300px;
  overflow: scroll;
}
.flexContainer{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.pre_text {
  display: grid;
  grid-template-columns: minmax(100px, 230px) 140px;
  margin: 10px 0px;
  gap: 8px;
}

.tooltip_container .tooltip_text{
 width: 70px;
}
.tooltip_container .tooltip_text.top {
  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 70%;
}
.uploadedImg{
  display: inline-block;
  width: auto;
  height: auto;
  max-height: 200px;
  max-width: 100%;
  object-fit: cover;
  border-radius: 5px;
}
.videoFallback {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 20px;
  background: var(--purple-opac);
  border-radius: 8px;
  text-align: center;
}
.uploadContainer{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
  height: 100%;
  margin-top: 50px;
}

.uploadContainer img {
  max-height: 120px;
}
.optionsContainer{
  margin: 20px 20px 20px;
}
.paddingBottom{
  padding-bottom: 8px;
}
.paddingLeft{
  padding-left: 10px;
}
.chatDisabledContainer{
  margin: 0px 15px;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loadingScreen{
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 80px auto 0px auto;
}
.emptyImg{
  max-width: 250px;
  width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
}
.uploadContainerfooter{
  display: flex;
  justify-content: center;
}

.custBorder{
  border-bottom: 1px solid var(--background-primary);
  padding: 10px 0px;
}
.productImg{
  width: 40px;
  border-radius: 5px;
  object-fit: cover;
}
.custPadding{
  padding-left: 10px;
}
.custMargin{
  margin: 10px 0px;
}
.sendMessageContainer{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 10px 20px;
}
.messageInputBox{
  padding: 10px 0px;
}

.normalchat_component{
  position: relative;
  display: inline-block;
  width: auto;
  max-width: 300px;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  padding: 14px 10px;
  background-color: var(--purple);
  color: var(--white);
  font-weight: 400;
  font-size: 14px;
  line-height: 1.4;
}

.normalchat_component a,
.normalchat_component a:hover,
.normalchat_component a:active,
.normalchat_component a:focus{
  color: var(--purple);
  text-decoration: underline;
}

.botMsgBubble .normalchat_component a,
.botMsgBubble .normalchat_component a:hover,
.botMsgBubble .normalchat_component a:active,
.botMsgBubble .normalchat_component a:focus{
  color: var(--purple);
  text-decoration: underline;
}
.botMsgBubble .normalchat_component{
  background-color: #fff;
  color: #000;
}
.statusInfo{
  background-color: var(--purple-opac);
  color: var(--black);
  text-align: left;
}

.active {
  color: var(--purple) !important;
}
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
.empty-message{
  margin: 50px 0px;
}
.flexBox{
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.icon{
  padding-right: 5px;
}
.imageContainer {
  text-align: center;
  width: 100%;
  margin: 30px 0px 20px 0px;
}
.documentContainer{
  border-radius: 5px;
  background: var(--background-primary);
  padding: 15px;
  margin: 20px 20px 0px 20px;
}
.documentContainer a{
  color: var(--black);
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
}
.livechat-header {
  box-shadow: none;
  border-bottom: 1px solid var(--background-primary);
}
.chatToolBar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  background: var(--white);
}
.liveChatDefault {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}
.customerDetails{
  height: 100%;
  background: var(--white) ;
}
.width50P{
  width: 50%;
}
.reminderMargin{
  margin: 0px !important;
}
.shortcut-table {
  display: flex;
  flex-direction: column;
  font-size: 14px;
}

.shortcut-header {
  display: flex;
  font-weight: bold;
  border-bottom: 1px solid var(--background-primary);
  padding: 8px 0;
  background: #f9f9f9;
}
.liveChatHeaderCustomerName{
  gap: 6px;
  margin: 10px 0px 10px 15px;
}
.shortcut-row {
  display: flex;
  padding: 8px 0;
  border-bottom: 1px solid var(--background-primary);
  cursor: pointer;
}

.shortcut-row:hover {
  background: #f5f5f5;
}

.shortcut-col {
  padding: 0 8px;
  overflow-wrap: anywhere;
}
.shortcut-col.name {
  width: 200px;
}
.shortcut-col.message {
  flex: 1;
  color: var(--black);
}
.no-results {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 40px;
  color: var(--gray-04);
}
.filterImg {
  width: 150px;
  height: auto;
  margin-bottom: 16px;
}
.disconnect_status{
  background-color: var(--warning);
  border-radius: 20px;
  color: var(--orange);
  padding: 5px 10px;
}
.uploadMargin{
  margin: 20px 20px 0px 20px;
}
.optin-status-tag{
  padding: 5px 10px;
  -webkit-border-radius: 20px;
  border-radius: 20px;
  font-size: 14px;
}
.optin-status-tag.optin-nostatus{
  background-color: #EDEDED;
  color: #54575E;
}
.optin-status-tag.optin-subscribed{
  background-color: #EAFDF2;
  color: #2DD36F;
}
.optin-status-tag.optin-unsubscribed{
  background-color: #FEE3DD;
  color: #FA7554;
}
.optin-status-tag img{
  vertical-align: middle;
  margin-right: 3px;
  height: 14px;
  width: auto;
}
.infoBanner.opted-out-banner {
  background-color: #FEE3DD;
  padding: 10px;
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  gap: 5px;
  font-size: 0.9rem;
  border-radius: 5px;
  margin: 0px 15px;
  margin-bottom: 0px;
  .icon {
    width: 20px;
    height: 20px;
  }
  .column, &.column {
    display: flex;
    flex-direction: column !important;
    gap: 5px;
    width: 100%;
  }
  .row {
    display: flex;
    flex-direction: row;
    gap: 5px;
    width: 100%;
    .item {
      width: 100%;
    }
  }
  .json-image {
    width: 100%;
    margin-top: 20px;
    img {
      width: 100%;
      border-radius: 5px;
    }
  }
  .icon.primary, .primary {
  color: #FA7554;
}
}

@media only screen and (max-width: 760px) {
  .sendMessageContainer{
    flex-direction: column;
  }
  .loadingScreen{
    margin: 80px 20px 0px 20px;
  }
  .marginleft{
    margin-left: 20px;
  }
  .header {
    max-width: 150px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .optin-status-tag > .status {
    display: none;
  }
  .optin-status-tag:hover {
    position: relative;
  }
  .optin-status-tag:hover > .status {
    display: flex;
    position: absolute;
    background-color: var(--black);
    color: var(--white);
    padding: 5px 10px;
    left: 30px;
    border-radius: 5px;
    white-space: nowrap;
    z-index: 10;
  }
}

/* New styles for migrated components */
.toolbar-end-buttons {
  display: flex;
  align-items: center;
}
.icon-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.chat-footer {
  border-top: 1px solid var(--background-primary);
}
.chat-toolbar {
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid var(--background-primary);
}
.toolbar-start-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
}
.text-medium {
  color: var(--gray-04);
}
.btn-outline-dark {
  background: transparent;
  border: 1px solid var(--black);
  color: var(--black);
  padding: 6px 12px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 13px;
}
.btn-outline-dark:hover {
  background: var(--background-primary);
}
.btn-sm {
  padding: 6px 12px;
  font-size: 13px;
}
.btn-primary {
  background: var(--purple);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
}
.btn-primary:hover {
  opacity: 0.9;
}
.btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.btn-outline-secondary {
  background: transparent;
  border: 1px solid var(--purple);
  color: var(--purple);
  padding: 8px 16px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
}
.btn-outline-secondary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.btn-block {
  width: 100%;
}
.botActiveTextNoticeBarOverInput {
  display: block;
  background: var(--purple-opac);
  color: var(--purple);
  padding: 8px 15px;
  border-radius: 5px;
  font-size: 13px;
  margin: 0px 15px 8px 15px;
}
.agent-list-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid var(--background-primary);
}
.loading-agents-indicator {
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  padding: 20px 0;
  justify-content: center;
}
.reassign-modal-body {
  overflow: visible;
  min-height: 350px;
}
.agent-item-content {
  flex: 1;
}
.agent-item-content h2 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
}
.agent-item-content p {
  margin: 4px 0 0 0;
  font-size: 12px;
  color: var(--gray-04);
}
.agent-item-name {
  flex: 1;
  font-size: 14px;
}
.action-sheet-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.action-sheet-item {
  display: flex;
  align-items: center;
  padding: 12px 0px;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 14px;
  border-radius: 5px;
  text-align: left;
  width: 100%;
  color: var(--black);
}
.action-sheet-item:hover {
  background: var(--background-primary);
}
.recent-files-header {
  display: flex;
  align-items: center;
}
.recent-file-row {
  display: flex;
  align-items: center;
}
.recent-file-item {
  display: flex;
  align-items: center;
}
.recent-files-col-8 {
  flex: 2;
}
.recent-files-col-4 {
  flex: 1;
}
.text-right {
  text-align: right;
}
</style>
